import { render, staticRenderFns } from "./CompanyTab.vue?vue&type=template&id=1c09f0da&"
import script from "./CompanyTab.vue?vue&type=script&lang=js&"
export * from "./CompanyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports